import Typography from '@mui/material/Typography';


export default function InfoCancerText() {
  
  return (
<div>
    
<Typography variant="h6" >
    
In this section, we scan your DNA for variants in genes associated with an increased risk of certain cancer types. 
We use clinically curated panels from trusted sources like ClinGen, where experts have carefully selected genes that are important for hereditary cancer risk.
<br /><br />

How to Read Your Results:<br /><br /> 
 Green color: No disease-associated variants were found.<br /> 
 Blue color: A variant with 'uncertain significance' was found in a gene linked to a disease phenotype.<br /> 
 Red color: A 'pathogenic' or 'likely pathogenic' variant was found in a gene linked to a disease phenotype.
 <br /><br /> 
Important:<br /> <br /> 

Finding a variant in a cancer-related gene does not mean you will definitely develop cancer. 
It indicates that there may be an increased risk, but many other factors — like lifestyle and environment — also influence whether cancer will actually develop.
<br /> <br /> 

In the context of cancer genetics, most variants act as risk factors, not as direct causes. Understanding these risks can be powerful, 
because there are many preventive measures and early detection programs available that can significantly improve outcomes.

<br /> <br /> 
Knowing about an increased hereditary cancer risk can help you:
<br /> <br /> 
 - Take preventive actions (such as lifestyle changes or preventive screenings).<br />
 - Participate in early detection programs to catch any changes as early as possible.<br />
 - Plan personalized healthcare strategies with your medical team.<br /><br />

Early detection often leads to better treatment options and greatly improves the chance of recovery. 
Genetic counseling is strongly recommended to discuss your results and next steps.
    
</Typography>    
</div>

   )
}